import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import createFolderRequest from 'owa-service/lib/factory/createFolderRequest';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import folder from 'owa-service/lib/factory/folder';
import folderId from 'owa-service/lib/factory/folderId';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import createFolderOperation from 'owa-service/lib/operation/createFolderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getDefaultRequestOptions from './getDefaultRequestOptions';

export default function createNewFolder(
    parentFolderId: string | DistinguishedFolderIdName,
    displayName: string,
    folderClass: string = 'IPF.Note'
): Promise<FolderInfoResponseMessage> {
    return createFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: createFolderRequest({
                ParentFolderId: targetFolderId({
                    BaseFolderId: createFolderId(parentFolderId),
                }),
                Folders: [
                    folder({
                        DisplayName: displayName,
                        FolderClass: folderClass,
                    }),
                ],
            }),
        },
        getDefaultRequestOptions(parentFolderId)
    ).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}

function createFolderId(parentFolderId: string | DistinguishedFolderIdName): BaseFolderId {
    if (typeof parentFolderId === 'string') {
        return folderId({ Id: parentFolderId });
    } else {
        return distinguishedFolderId({ Id: parentFolderId });
    }
}
